import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Image from "next/image";
import "./CitiesPopup.styles.scss";
import { setCity } from "@/redux/slices/locationSlice";
import { closePopup } from "@/redux/slices/popupSlice";
const CitiesPopup = () => {
  const { popupData } = useSelector((state) => state.popups);
  const { city } = useSelector((state) => state.location);
  const dispatch = useDispatch();
  const handleCityButtonClick = (cityLabel) => {
    dispatch(
      setCity({
        selectedCity: cityLabel,
      })
    );
    dispatch(closePopup());
  };
  return (
    <div className="city-popup-main-container">
      <h2 className="cities-header">Top Cities</h2>
      <div className="cities-list-container">
        {popupData?.map((cityItem, index) => {
          return (
            <div
              className={`city-item-container ${
                cityItem.value === city ? "active" : ""
              }`}
              key={`cities-${index}-${cityItem.label}`}
              role="button"
              onClick={() => handleCityButtonClick(cityItem.label)}
            >
              <Image
                className="city-image-icon"
                src={cityItem.icons}
                alt={cityItem.label}
                width={50}
                height={50}
              />
              <p className="city-label">{cityItem.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CitiesPopup;
